export default __webpack_public_path__ + "static/media/connect.fd965ddb.svg";